import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  module: null,
  formValue: null,
};

const searchFormSlice = createSlice({
  name: 'searchForm',
  initialState,
  reducers: {
    setSearchFormModule: (state, action) => {
      state.module = action.payload;
    },
    setSearchFormValue: (state, action) => {
      state.formValue = action.payload;
    },
    clearSearchForm: () => initialState,
  },
});

export const { setSearchFormModule, setSearchFormValue, clearSearchForm } = searchFormSlice.actions;
export default searchFormSlice.reducer;
